/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubscriptionStatesEnum } from './subscriptionStatesEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { SubscriptionResponse } from './subscriptionResponse';
import { OfferRegionEnum } from './offerRegionEnum';
import { DataCentersEnum } from './dataCentersEnum';
import { SubscriptionTypeEnum } from './subscriptionTypeEnum';


export interface Subscription { 
    activation_request_date?: Date;
    activation_requested?: boolean;
    cancellation_requested?: boolean;
    created_by?: string;
    data_center?: DataCentersEnum;
    migrated?: boolean;
    migrated_by?: string;
    offer_region?: OfferRegionEnum;
    org_id?: string;
    request_date?: Date;
    service_type?: ServiceTypeEnum;
    start_date?: Date;
    state?: SubscriptionStatesEnum;
    subscription_id?: string;
    subscription_response?: SubscriptionResponse;
    subscription_type?: SubscriptionTypeEnum;
    task_id?: string;
}
export namespace Subscription {
}


